
import React from 'react';
import {NavLink, BrowserRouter as Router, Route, Routes} from 'react-router-dom';

import Events from './Events';
import News from './News';
import Contact from './Contact';
import Home from './Home';
import Firm from './Firm';
import People from './People';
import Testimonials from './Testimonials';
import Articles from './ArticleList';
import ArticleDetail from './ArticleDetail';

import AboutDetail from './AboutDetail';

// If using React Router
import { useParams } from 'react-router-dom';


function App() {
    
    return (<div className="App">
		<Router>

		    <div className="container">
		    <header className="d-flex flex-wrap align-items-center justify-content-center justify-content-md-between py-3 mb-4 border-bottom">
			<div className="col-md-3 mb-2 mb-md-0">
			    <img src="/liza-khan-logo.png" height="168" />
			</div>
			<nav>
			<ul className="nav col-12 col-md-auto mb-2 justify-content-center mb-md-0">
			    <li><NavLink to="/" className={({ isActive }) => isActive ? "px-2 active" : "px-2 nonactive"} >Home</NavLink></li>
			    <li><NavLink to="/firm" className={({ isActive }) => isActive ? "px-2 active" : "px-2 nonactive"} >The Firm</NavLink></li>
			    <li><NavLink to="/people" className={({ isActive }) => isActive ? "px-2 active" : "px-2 nonactive"} >Our People</NavLink></li>
			    <li><NavLink to="/testimonials" className={({ isActive }) => isActive ? "px-2 active" : "px-2 nonactive"} >What People Say</NavLink></li>
			    <li><NavLink to="/articles" className={({ isActive }) => isActive ? "px-2 active" : "px-2 nonactive"} >Articles</NavLink></li>
			    <li><NavLink to="/contact" className={({ isActive }) => isActive ? "px-2 active" : "px-2 nonactive"} >Contact</NavLink></li>			    
			</ul>
			</nav>
			<div className="col-md-3 text-end">
			    {/*  <button type="button" className="btn btn-outline-primary me-2">Enquire</button> 
			    <button type="button" className="btn btn-primary">Sign-up</button> */}
			</div>
		    </header>
		    </div>
		    <div className="b-example-divider"></div>
			<Routes>
			    <Route path="/" element={<Home />} />
			    <Route path="/about/:id" element={<AboutDetailPage />} />
			    <Route path="/people" element={<People />} />
			    <Route path="/firm" element={<Firm />} />
			    <Route path="/events" element={<Events />} />
			    <Route path="/contact" element={<Contact />} />
			    <Route path="/articles" element={<Articles />} />
			    <Route path="/testimonials" element={<Testimonials />} />
			    <Route path="/article/:id" element={<ArticleDetailPage />} />
			</Routes>

		</Router>

		
		<div className="container">
		    <footer className="d-flex flex-wrap justify-content-between align-items-center py-3 my-4 border-top">
			<div className="col-md-4 d-flex align-items-center">
			    <a href="/" className="mb-3 me-2 mb-md-0 text-body-secondary text-decoration-none lh-1">
				<svg className="bi" width="30" height="24"><use xlinkHref="#bootstrap"></use></svg>
			    </a>
			    <span className="mb-3 mb-md-0 text-body-secondary">© 2024 Liza Khan Chambers</span>
			</div>

			<ul className="nav col-md-4 justify-content-end list-unstyled d-flex">
			    <li className="ms-3"><a className="text-body-secondary" href="#"><svg className="bi" width="24" height="24"><use xlinkHref="#twitter"></use></svg></a></li>
			    <li className="ms-3"><a className="text-body-secondary" href="#"><svg className="bi" width="24" height="24"><use xlinkHref="#instagram"></use></svg></a></li>
			    <li className="ms-3"><a className="text-body-secondary" href="#"><svg className="bi" width="24" height="24"><use xlinkHref="#facebook"></use></svg></a></li>
			</ul>
		    </footer>
		</div>
	    </div>

	   );
}



// Wrapper component to extract URL parameter and pass to ArticleDetail
function ArticleDetailPage() {
  const { id } = useParams();
  return <ArticleDetail articleId={id} />;
}


// Wrapper component to extract URL parameter and pass to AboutDetail
function AboutDetailPage() {
  const { id } = useParams();
  return <AboutDetail articleId={id} />;
}

export default App;
